<template>
  <el-container style="height: 100vh;">
    <el-aside width="220px" style="background:#143c34;color:#fff;">
      <div style="padding:20px;font-size:20px;font-weight:700;">生态哨兵后台</div>
      <el-menu
        :default-active="$route.path"
        background-color="#143c34"
        text-color="#fff"
        active-text-color="#ffd04b"
        router>
        <el-menu-item index="/dashboard">概览</el-menu-item>
        <el-menu-item index="/records">记录审核</el-menu-item>
        <el-menu-item index="/users">用户管理</el-menu-item>
        <el-menu-item index="/projects">项目管理</el-menu-item>
        <el-menu-item index="/badges">徽章管理</el-menu-item>
        <el-menu-item index="/banners">Banner管理</el-menu-item>
        <el-menu-item index="/poster-templates">海报模板</el-menu-item>
        <el-menu-item index="/configs">系统配置</el-menu-item>
        <el-menu-item index="/agreements">协议管理</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header style="display:flex;justify-content:space-between;align-items:center;background:#fff;border-bottom:1px solid #eee;">
        <div>{{ pageTitle }}</div>
        <el-button type="text" @click="logout">退出登录</el-button>
      </el-header>
      <el-main style="background:#f5f7fa;">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  computed: {
    pageTitle () {
      return {
        '/dashboard': '数据概览',
        '/records': '记录审核',
        '/users': '用户管理',
        '/projects': '项目管理',
        '/badges': '徽章管理',
        '/banners': 'Banner管理',
        '/poster-templates': '海报模板管理',
        '/configs': '系统配置',
        '/agreements': '协议管理'
      }[this.$route.path] || '生态哨兵后台'
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('admin_token')
      this.$store.commit('clearAdminInfo')
      this.$router.replace('/login')
    }
  }
}
</script>
